import { Link } from "react-router-dom";
import { AnchorLink } from "@/components/AnchorLink";

const LINKS = [
  { label: "Meet Peanut Valet", to: "#meet", testId: "footer-link-meet" },
  { label: "Our Vision", to: "#vision", testId: "footer-link-vision" },
  { label: "Keep Me Updated", to: "#signup", testId: "footer-link-signup" },
  { label: "Partner With Us", to: "#partner", testId: "footer-link-partner" },
];

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#043436] text-[#F7F1E6]">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8 lg:py-16">
      <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
        <div>
          <img
            data-testid="footer-logo"
            src="/assets/peanut-valet-logo.webp"
            alt="Peanut Valet logo"
            className="h-16 w-auto"
            width="720"
            height="476"
            loading="lazy"
          />
          <p className="mt-4 text-base font-semibold text-[#EADCC6]">
            A new twist on snack time.
          </p>
        </div>
        <nav aria-label="Footer navigation" className="flex flex-col gap-3 sm:flex-row sm:flex-wrap sm:gap-x-8">
          {LINKS.map((l) => (
            <AnchorLink
              key={l.to}
              to={l.to}
              testId={l.testId}
              className="text-left text-[15px] font-bold text-[#F7F1E6] transition-colors duration-200 hover:text-[#F3802A]"
            >
              {l.label}
            </AnchorLink>
          ))}
          <Link
            to="/privacy"
            data-testid="footer-link-privacy"
            className="text-[15px] font-bold text-[#F7F1E6] transition-colors duration-200 hover:text-[#F3802A]"
          >
            Privacy Policy
          </Link>
        </nav>
      </div>
      <div className="mt-12 border-t border-[#115B5B] pt-6 text-sm text-[#EADCC6]/70">
        <p>&copy; {new Date().getFullYear()} Peanut Valet. All rights reserved.</p>
        <p className="mt-2">Product in development. Product images and video are rendered visuals of the design vision.</p>
      </div>
    </div>
  </footer>
);
